import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { Building, Plane, Landmark, Scale, Cog, Handshake, Megaphone, Award, ArrowRight } from 'lucide-react';

const icons = [Building, Plane, Landmark, Scale, Cog, Handshake, Megaphone, Award];

const Services = () => {
  const { t } = useLang();
  return (
    <div>
      <PageHero eyebrow={t.services.eyebrow} title={t.services.title} desc={t.bridge.desc} />
      <section className="bg-[#FBF9F2] py-20">
        <div className="sib-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {t.services.list.map((s, i) => {
              const Icon = icons[i] || Building;
              return (
                <Link key={s.slug} to={`/services/${s.slug}`} className="bg-white border border-[#E8E1CE] rounded-lg p-7 card-hover group flex flex-col">
                  <div className="w-12 h-12 rounded-md bg-[#0B5D3B]/10 flex items-center justify-center mb-4 group-hover:bg-[#D4A840]/20 transition"><Icon className="w-6 h-6 text-[#0B5D3B] group-hover:text-[#D4A840] transition" /></div>
                  <h3 className="text-lg font-semibold text-[#0B5D3B] mb-2">{s.title}</h3>
                  <p className="text-[14px] text-[#33473d]/85 leading-relaxed mb-5 flex-1">{s.short}</p>
                  <div className="text-[#0B5D3B] font-semibold text-sm inline-flex items-center gap-1 group-hover:text-[#D4A840]">{t.services.viewService}<ArrowRight size={14} className="rtl-flip" /></div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
};
export default Services;
